// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable require-await, babel/camelcase */
import type { Dispatch } from "redux"
import getErrorMessage from "@kiwicom/frontend-common/services/utils/getErrorMessage"

import { transport } from "../../../../../../../services/api/transport"
import type { BookingId } from "../../../../../../../types/primitiveTypes"
import { ACTIONS, CONTEXTS } from "../../../../../../../consts/booking"
import { ACTION, INVALIDATE_END, INVALIDATE_START } from "../../../services/consts"
import type {
  BookingInvalidateEndAction,
  BookingInvalidateStartAction,
} from "../../../services/types"
import { BookingActionSuccessAction } from "../../../services/types"
import type { AdditionalContact, FieldPropsForSubmit } from "./consts"
import { pickAdditionalContactsProps } from "./additionalContactsMapper"
import Booking from "../../../../../../../records/Booking"

export type AdditionalContactsApiPayload = {
  bid: BookingId
  contact: number
  current: AdditionalContact[]
  created: FieldPropsForSubmit[]
  removed: number[]
}

export const additionalContactsApi = (
  payload: AdditionalContactsApiPayload,
  context: string = CONTEXTS.MMB,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => async (dispatch: Dispatch<any>) => {
  dispatch({ type: INVALIDATE_START } as BookingInvalidateStartAction)
  dispatch({
    type: `${ACTION}_REQUEST`,
    action: ACTIONS.ADDITIONAL_CONTACTS,
    bid: payload.bid,
    payload,
    _track: { action: ACTIONS.ADDITIONAL_CONTACTS, payload, context },
    original_type: ACTION,
  })

  const toBeAdded: Promise<{
    contacts: AdditionalContact[]
  }> | null = payload.created.length
    ? transport(
        "POST",
        payload.bid,
        `/mmb/v1/bookings/${payload.bid}/contacts`,
        null,
        payload.created,
      )
    : null

  const toBeDeleted: Promise<null>[] = payload.removed.map((id) =>
    // @ts-expect-error: Flow to TS migration.
    transport("DELETE", payload.bid, `/mmb/v1/bookings/${payload.bid}/contacts/${id}`),
  )

  return (
    Promise.all([toBeAdded, ...toBeDeleted])
      // Fix this the next time the file is edited. (Flow to TS)
      // @ts-expect-error: Flow to TS migration.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then(([added, ...removed]: [any, any]) => {
        let updatedContacts = payload.current

        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (removed.length) {
          updatedContacts = updatedContacts.filter((item) => !payload.removed.includes(item.id))
        }

        if (added) {
          updatedContacts = [...updatedContacts, ...pickAdditionalContactsProps(added.contacts)]
        }

        dispatch({
          type: `${ACTION}_SUCCESS`,
          action: ACTIONS.ADDITIONAL_CONTACTS,
          bid: payload.bid,
          payload,
          _track: { action: ACTIONS.ADDITIONAL_CONTACTS, payload, context },
          original_type: ACTION,
          // this is the actual new state to be merged - see reducer below
          newAdditionalContacts: updatedContacts,
        })

        return true
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error)

        dispatch({
          type: `${ACTION}_FAILURE`,
          action: ACTIONS.ADDITIONAL_CONTACTS,
          bid: payload.bid,
          payload,
          original_type: ACTION,
          error: errorMessage,
          _track: {
            error: error.toString(),
            parsedError: errorMessage,
            unknownError: errorMessage === "unknown error",
          },
        })

        return false
      })
      .then((ok) => {
        dispatch({ type: INVALIDATE_END } as BookingInvalidateEndAction)
        return ok
      })
  )
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const additionalContactsReducer = (state: any, action: BookingActionSuccessAction) => {
  const updatedBooking = new Booking({
    ...state.data,
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    additionalContacts: action.newAdditionalContacts || [],
  })
  return state.set("data", updatedBooking)
}

export default additionalContactsApi
